/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Underline_Selected_EventsInputs */

const en_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Underline selected events`)
};

const fr_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souligner les événements sélectionnés`)
};

const de_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Ereignisse unterstreichen`)
};

const it_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottolinea gli eventi selezionati`)
};

const ru_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подчеркните выбранные события`)
};

const es_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subrayar eventos seleccionados`)
};

const zh_cn2_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用下划线标出选定的事件`)
};

const ja_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントに下線を付ける`)
};

const hi_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं को रेखांकित करें`)
};

const pt_pt2_underline_selected_events = /** @type {(inputs: Underline_Selected_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sublinhe os eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Underline selected events" |
*
* @param {Underline_Selected_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const underline_selected_events = /** @type {((inputs?: Underline_Selected_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Underline_Selected_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_underline_selected_events(inputs)
	if (locale === "de") return de_underline_selected_events(inputs)
	if (locale === "it") return it_underline_selected_events(inputs)
	if (locale === "ru") return ru_underline_selected_events(inputs)
	if (locale === "es") return es_underline_selected_events(inputs)
	if (locale === "zh-CN") return zh_cn2_underline_selected_events(inputs)
	if (locale === "ja") return ja_underline_selected_events(inputs)
	if (locale === "hi") return hi_underline_selected_events(inputs)
	if (locale === "pt-PT") return pt_pt2_underline_selected_events(inputs)
	return en_underline_selected_events(inputs)
});